import { useGetVisitaByIdQuery, useUpdateStatusMutation } from "../../../../api/visitasApi";
import { Dispatch, SetStateAction, useState } from "react";
import { CurrentComponent } from "./DealInformation";
import { SaveButton } from "../../../UtilitiesComponents/SaveButton";
import { CancelButton } from "../../../UtilitiesComponents/CancelButton";
import { AddIntenciones } from "./AddIntenciones";
import { CircularProgress } from "@mui/joy";
import { Intencion } from "../../../../types/empresa";
import { UpdateStatusRequest } from "../../../../types/visitas";
import { ErrorMessage } from "../../../UtilitiesComponents/ErrorMessage";
import { getErrorMessage } from "../../../../utils/errorHelpers";

interface Props {
    visitaId: number;
    setCurrentComponent: Dispatch<SetStateAction<CurrentComponent>>;
}

export function FinishVisitaForm({ visitaId, setCurrentComponent }: Props) {
    const [intenciones, setIntenciones] = useState<Intencion[]>([]);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const { data: visita, isFetching } = useGetVisitaByIdQuery(visitaId);
    const [ updateStatus, { isLoading }] = useUpdateStatusMutation()

    const handleUpdateStatus = async () => {
        try {
            setErrorMessage(null);

            const request: UpdateStatusRequest = {
                visitaId,
                status: "Terminada",
                intenciones,
            };

            await updateStatus(request).unwrap();

            setCurrentComponent({ component: "Visita", visitaId: visitaId });
        } catch (error) {
            setErrorMessage(getErrorMessage(error));
        }
    }

    if(isFetching)
        return (
        <div className="flex justify-center items-center w-full h-full">
            <CircularProgress />
        </div>
    );

    return (
        <div className="w-full flex flex-col overflow-hidden flex-1">

            <p className="text-lg font-semibold">Terminar visita del dia {visita?.fecha}</p>

            <div className="flex gap-x-3">
                <div className="flex-1">
                    <label className="text-sm font-semibold">Hora de inicio</label>
                    <input
                        value={visita?.horaInicio}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm disabled:bg-white"/>
                </div>

                <div className="flex-1">
                    <label className="text-sm font-semibold">Hora de fin</label>
                    <input
                        value={visita?.horaFin}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm disabled:bg-white"/>
                </div>

                <div className="flex-1">
                    <label className="text-sm font-semibold">Turno</label>
                    <input
                        value={visita?.turno}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm disabled:bg-white" />
                </div>
            </div>

            <div>
                <label className="text-sm font-semibold">Prospectador</label>
                <input 
                    value={visita?.prospectador}
                    type="text" 
                    disabled
                    className="
                        w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                        font-semibold text-gray-600 text-sm disabled:bg-white" />
            </div>

            <AddIntenciones
                visitaId={visitaId}
                intenciones={intenciones} 
                setIntenciones={setIntenciones} />
            
            {errorMessage && (
                <div className="my-2">
                    <ErrorMessage
                        customMessage>
                        <p className="text-sm">{errorMessage}</p>
                    </ErrorMessage>
                </div>
            )}

            <div className="flex gap-x-2 justify-center pt-1">
                {isLoading
                ?
                <CircularProgress sx={{
                    "--CircularProgress-progressThickness": "4px",
                    "--CircularProgress-trackThickness": "4px",
                    "--CircularProgress-size": "24px"
                }}/>
                :
                <>
                <SaveButton
                    text="Terminar"
                    onClick={handleUpdateStatus}
                    type="button"/>

                <CancelButton
                    text="Cancelar"
                    onClick={()=> {
                        setCurrentComponent({ component: "Visita", visitaId: visitaId });
                    }} />
                </>
                }
            </div>

        </div>
    );
}